module.exports = __webpack_public_path__ + "img/UploadPACS.d48a3396.svg";